import { render, staticRenderFns } from "./CrudBase.vue?vue&type=template&id=2dab4d51&scoped=true"
import script from "./CrudBase.vue?vue&type=script&lang=js"
export * from "./CrudBase.vue?vue&type=script&lang=js"
import style0 from "./CrudBase.vue?vue&type=style&index=0&id=2dab4d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab4d51",
  null
  
)

export default component.exports